import { render, staticRenderFns } from "./meetingFooter.vue?vue&type=template&id=8b163ef0&scoped=true&"
import script from "./meetingFooter.vue?vue&type=script&lang=js&"
export * from "./meetingFooter.vue?vue&type=script&lang=js&"
import style0 from "./meetingFooter.vue?vue&type=style&index=0&id=8b163ef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b163ef0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b163ef0')) {
      api.createRecord('8b163ef0', component.options)
    } else {
      api.reload('8b163ef0', component.options)
    }
    module.hot.accept("./meetingFooter.vue?vue&type=template&id=8b163ef0&scoped=true&", function () {
      api.rerender('8b163ef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/meetingFooter.vue"
export default component.exports